import React from 'react';
import { Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartNetwork, faMobile, faLineChart } from '@fortawesome/pro-regular-svg-icons';
import collageImage from '../../../RAA_AlertingImage_221206_RedAccent.png';

const highlightStyle = { backgroundColor: '#fff176', padding: '0 0.15rem' };

const FreeTrialMarketingPanel = () => (
  <div>
    <p className="h5 font-weight-bold mb-4 mx-5">
      Your Room Alert equipment is designed to work with Room Alert Account.
      Try the full experience,
      {' '}
      <span style={highlightStyle}>free for 3 months.</span>
    </p>

    <Image src={collageImage} alt="Room Alert monitoring in action" fluid className="mb-4 mt-2" />

    <ul className="list-unstyled mx-5 mt-3">
      <li className="d-flex mb-3">
        <div className="text-danger mr-4 mt-1 text-center" style={{ width: '2rem', flexShrink: 0 }}>
          <FontAwesomeIcon icon={faChartNetwork} size="2x" />
        </div>
        <span className="ml-2">
          <strong>Centralized Management:</strong>
          {' '}
          View every monitor and
          sensor across multiple locations and manage all of your alerts in one place.
        </span>
      </li>
      <li className="d-flex mb-3">
        <div className="text-danger mr-4 mt-1 text-center" style={{ width: '2rem', flexShrink: 0 }}>
          <FontAwesomeIcon icon={faMobile} size="2x" style={{ marginLeft: '0.35rem' }} />
        </div>
        <span className="ml-2">
          <strong>Mobile Notifications:</strong>
          {' '}
          Get messages pushed right to
          your phone via the Room Alert App or set up native SMS messages.
        </span>
      </li>
      <li className="d-flex mb-3">
        <div className="text-danger mr-4 mt-1 text-center" style={{ width: '2rem', flexShrink: 0 }}>
          <FontAwesomeIcon icon={faLineChart} size="2x" />
        </div>
        <span className="ml-2">
          <strong>Sensor Data History:</strong>
          {' '}
          Track trends and better
          understand your environment by visualizing your sensor data over time.
        </span>
      </li>
    </ul>
  </div>
);

export default FreeTrialMarketingPanel;
